import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { Typography } from "@mui/material";

const CustomLocationLoader = ({data}) => {
  // Parse your location object from the message
  const {
    address,
    latitude,
    longitude,
    name,
    url,
  } = data;

  return (
    <div style={{ height: "250px", width: "100%",maxHeight: "300px"}}>
      <MapContainer
        center={[latitude, longitude]}
        zoom={15}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={[latitude, longitude]} icon={window.L && window.L.Icon ? new window.L.Icon({
          iconUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon.png",
          iconRetinaUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-icon-2x.png",
          shadowUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png",
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41]
        }) : undefined}>
          <Popup>
            <strong>{name}</strong>
            <br />
            {address}
            <br />
            <a href={url} target="_blank" rel="noreferrer">
              Visit Site
            </a>
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default CustomLocationLoader;
